import React from 'react';
import { motion } from 'framer-motion';
import { CalendarDaysIcon, MapPinIcon, ArrowDownIcon } from 'lucide-react';
import { HERO_IMG, RESERVA_LINK } from '../../data/retiro';
export function Hero() {
  return <section id="top" className="relative flex min-h-screen w-full items-center justify-center overflow-hidden" data-id="element-88">
      <div className="absolute inset-0" data-id="element-89">
        <img src={HERO_IMG} alt="Amanecer dorado sobre los arrozales sagrados y templos de Ubud, Bali" className="h-full w-full object-cover" data-id="element-90" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(180deg, rgba(42,36,32,0.55) 0%, rgba(42,36,32,0.25) 40%, rgba(42,36,32,0.78) 100%)'
      }} data-id="element-91" />
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-4xl flex-col items-center px-5 pt-24 text-center text-white" data-id="element-92">
        <motion.span initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/30 px-4 py-1.5 text-xs uppercase tracking-[0.3em] backdrop-blur-sm" data-id="element-93">
          Retiro Espiritual · Bali
        </motion.span>

        <motion.h1 initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.1
      }} className="font-heading text-4xl font-light leading-[1.05] sm:text-6xl md:text-7xl" data-id="element-94">
          Su Nombre
          <br data-id="element-95" />
          es{' '}
          <span style={{
          color: 'var(--jasmine)'
        }} data-id="element-96">
            Amor
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.25
      }} className="mt-6 max-w-2xl text-base leading-relaxed text-white/85 sm:text-lg" data-id="element-97">
          Un viaje sagrado hacia tu esencia más profunda. Donde la naturaleza,
          los elementos y la magia ancestral te devuelven a ti.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.4
      }} className="mt-8 flex flex-col items-center gap-4 text-sm text-white/90 sm:flex-row sm:gap-8" data-id="element-98">
          <span className="inline-flex items-center gap-2" data-id="element-99">
            <CalendarDaysIcon className="h-4 w-4" style={{
            color: 'var(--jasmine)'
          }} data-id="element-100" />
            10 — 17 de octubre de 2026
          </span>
          <span className="hidden h-4 w-px bg-white/30 sm:block" data-id="element-101" />
          <span className="inline-flex items-center gap-2" data-id="element-102">
            <MapPinIcon className="h-4 w-4" style={{
            color: 'var(--jasmine)'
          }} data-id="element-103" />
            Ubud, Bali · Indonesia
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.55
      }} className="mt-10 flex flex-col items-center gap-3 sm:flex-row" data-id="element-104">
          <a href={RESERVA_LINK} className="rounded-full px-8 py-3.5 text-sm font-medium text-white transition-transform hover:scale-[1.04]" style={{
          backgroundColor: 'var(--darkgoldenrod)'
        }} data-id="element-105">
            Reserva tu lugar
          </a>
          <a href="#isla" className="rounded-full border border-white/40 px-8 py-3.5 text-sm font-medium text-white backdrop-blur-sm transition-colors hover:bg-white/10" data-id="element-106">
            Descubre el viaje
          </a>
        </motion.div>
      </div>

      <motion.a href="#isla" aria-label="Desplázate hacia abajo" className="absolute bottom-8 z-10 text-white/70" animate={{
      y: [0, 10, 0]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-107">
        <ArrowDownIcon className="h-6 w-6" data-id="element-108" />
      </motion.a>
    </section>;
}